export default "__VITE_ASSET__DOYDuHEi__"